import React, { useState } from 'react';
import AboutUs from "./AboutUs";
import Features from "./Features";
import Message from "./Message";
import Quote from "./Quote";
import Services from "./Services";
import Home from './Home';
import Slider from './Slider';
import OurWork from './ourWork';
import TheName from './theName';
import OurTeam  from './ourTeam ';
import ThirdQuote from './thirdQuote';
import StoreIcon from './storeIcon';
import { ScrollToTop } from './Scroll/ScrollToTop';
import Footer from './footer';
// import './Main.css';

import { Firstquote1, Secondquote1 } from '../components/Data/Arabic';
import { Firstquote2, Secondquote2 } from '../components/Data/English';

const Main = () => {

  const [lang, setLang] = useState(false);

  const handleLanguageChangeA = () => setLang(false);
  const handleLanguageChangeB = () => setLang(true);

  return (
    <div className={lang ? 'mb-[32] direction2' : 'mb-[32] direction1'} >
        <Home lang={lang} handleLanguageChangeA={handleLanguageChangeA}
         handleLanguageChangeB={handleLanguageChangeB} />
        <Message lang={lang} />
        <AboutUs lang={lang} />

        {/* first quote */}
        <Quote text={lang ? Firstquote2 : Firstquote1} /> 

        <Services lang={lang} />
        <Features lang={lang}  />
        <Slider />
 
        {/* second quote */}
        <Quote text={lang ? Secondquote2 : Secondquote1} />

         <OurWork />  
        <TheName lang={lang} />
        <OurTeam lang={lang} />
        <ThirdQuote lang={lang} />
        <StoreIcon />
        <Footer />
        <ScrollToTop />
    </div>

  )
}

export default Main;


